import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import queryString from 'query-string';
import axios from 'axios';
import moment from 'moment';
import { Segment, Dimmer, Loader, Message, Card, Icon } from 'semantic-ui-react';

import PaidReport from 'dyzio-shared-components/lib/reports/paid-report';
import BasicReport from 'dyzio-shared-components/lib/reports/basic-report';
import InsightsReport from 'dyzio-shared-components/lib/reports/insights-report';
import ROIReport from 'dyzio-shared-components/lib/reports/roi-report';
import ShopifyReport from 'dyzio-shared-components/lib/reports/shopify-report';
import PrestaShopReport from 'dyzio-shared-components/lib/reports/prestaShop-report';
import GoogleAnalyticsReport from 'dyzio-shared-components/lib/reports/google-analytics-report';
import EMVReport from 'dyzio-shared-components/lib/reports/emv-report';
import InstagramReport from 'dyzio-shared-components/lib/reports/instagram-report';
import InstagramReport2 from 'dyzio-shared-components/lib/reports/instagram-report2';
import TiktokReport from 'dyzio-shared-components/lib/reports/tiktok-report';
import TopHeader from 'dyzio-shared-components/lib/components/top-header';
import CampaignInsightsReport from 'dyzio-shared-components/lib/reports/campaign-insights-report';
import FollowersReport from 'dyzio-shared-components/lib/reports/followers-report';

import AuthReport from 'dyzio-shared-components/lib/reports/auth-report';
import UserDetailsModal from '../../components/user-details-modal';
import HeroReport from '../../components/hero-report';

const REPORT_TIMEOUT = 50000;
const DEFAULT_PER_DAYS = 90;
const PROFILE_KEY = 'DYZIO_PROFILE';

const IS_PRODUCTION = process.env.NODE_ENV === 'production';
const PROFILE_REQUIRED_DOMAINS = [
  // 'reports.dyzio.co',
  // 'share.dyzio.co',
];

const BLEND_CAMPAIGN_ID = 'ccee3b07-56bc-48e6-a769-d25c353efc95';

const reportTypes = {
  gi: 'Campaign',
  basic: 'Campaign',
  campaign: 'Campaign',
  instagram: 'Instagram',
  instagram2: 'Instagram2',
  auth: 'Authorisation Status',
  insights: 'Insights',
  roi: 'ROI',
  paid: 'Paid',
  emv: 'Earned Media Value (EMV)',
  ga: 'Google Analytics',
  shopify: 'Shopify',
  prestashop: 'Prestashop',
  campaignInsights: 'Campaign Insights',
  followers: 'Follower Growth',
};

const loadingSegmentStyle = { height: 175 };

const daysOptions = [
  { label: '30 days', value: 30, id: 30 },
  { label: '90 days', value: 90, id: 90 },
  { label: '120 days', value: 120, id: 120 },
  { label: 'all days', value: -1, id: 'all' },
];

const isBasicReport = type => _.includes(['basic', 'campaign', 'super'], _.toLower(type));
const shouldReloadOnPeriodFilter = arg => !_.isNull(arg.start) || !_.isNull(arg.end);

class Report extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  constructor(props) {
    super(props);
    const { dayFilterValue } = props.match.params;
    const reportPerDays = _.find(daysOptions, ['value', _.toNumber(dayFilterValue || DEFAULT_PER_DAYS)]);
    this.state = {
      type: null,
      id: null,
      error: false,
      profile: null,
      campaign: null,
      isLoadingReport: false,
      isLoadingCampaign: true,
      isReportBlocked: false,
      isLoadingMarketingCampaigns: false,
      isReportLoaded: false,
      loadingMarketingCampaignsFailed: false,
      data: null,
      sort: 'values.totals.followersCount',
      groupBy: 'influencer',
      order: {
        basic: {
          field: null,
          value: null,
        },
      },
      reportPerDays,
      datePeriodFilter: {
        start: null,
        end: null,
      },
      filter: {
        basic: {
          platform: null,
          handle: null,
        },
      },
    };

    // TODO Generate token, refactor this code
    this.client = axios.create({
      // baseURL: process.env.REACT_APP_REPORT_API_URL,
      baseURL: 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production',
      timeout: REPORT_TIMEOUT,
    });
    this.notifyClient = axios.create({
      baseURL: process.env.REACT_APP_NOTIFY_API_URL,
      timeout: 2000,
      headers: {
        Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhcHBfbWV0YWRhdGEiOnsicm9sZXMiOlsidXNlciJdLCJkeXppbyI6eyJ1X2lkIjoiZGVhNDVhMmMtYWQ0MS00OGQ2LWIxYjQtOGFlZjQ1NjZjNGZiIiwibmFtZSI6IkRhbiBDYW50aXIiLCJlbWFpbCI6ImRhbi5jYW50aXJAYXRvbWF0ZS5uZXQiLCJvX2lkIjoiZjE0ZDM5MzEtMGU2YS00MmU4LWFkM2MtYWUyZmYwN2UzZDk2Iiwicm9sZSI6IlRFQU1fTUVNQkVSIiwidmVyc2lvbiI6MX19LCJpc3MiOiJodHRwczovL2R5emlvLmV1LmF1dGgwLmNvbS8iLCJzdWIiOiJhdXRoMHw1OGI1NmMxYmIzM2M1NTQ2Nzg3YWE0NTYiLCJhdWQiOiJNeHVFWmthWHF1Wm5sSmVMOW9FOFFoeVF6aE10amZUcCIsImlhdCI6MTUwOTcwNzU2NCwiZXhwIjoxNTA5NzQzNTY0fQ.sIKlNtois5uMAKWrGD4tsfiNtT7JsqSnamFVRmRFXmg',
      },
    });
  }

  isCollaborationReport = () => {
    const { location } = this.props;
    const isCollaborationReport = !_.isEmpty(location.pathname.match(/^\/collab\//));
    return isCollaborationReport;
  }

  componentDidMount = () => {
    let { id } = this.props.match.params;

    const { location } = this.props;
    const qs = location.search;
    const parsed = queryString.parse(qs);
    console.log('parsed', parsed);

    const datePeriodFilter = {};
    if (_.get(parsed, 'start')) {
      datePeriodFilter.start = moment(_.get(parsed, 'start'));
    }

    if (_.get(parsed, 'end')) {
      datePeriodFilter.end = moment(_.get(parsed, 'end'));
    }
    this.setState({
      datePeriodFilter,
    });

    const isCollaborationReport = this.isCollaborationReport();

    if (id === 'csa-super') id = '535d32d6-fccc-4f13-8a31-89b96208c23d';
    const profile = this.getProfile();
    this.setState({
      profile,
    }, () => {
      const campaignUrl = `campaign/fields?id=${id}${isCollaborationReport ? '&t=c' : ''}`;
      this.client.get(campaignUrl).then(response => {
        const {
          data: {
            data: {
              name,
              campaignType,
              hashtags,
              liveDate,
              endDate,
              createdBy,
              country,
              marketingCampaigns,
              documents,
              overview,
              owner,
            },
          },
        } = response;
        this.setState({
          isLoadingCampaign: false,
          isLoadingReport: true,
          campaign: {
            id,
            name,
            campaignType,
            hashtags,
            liveDate,
            endDate,
            createdBy,
            country,
            marketingCampaigns,
            documents,
            overview,
            owner,
          } }, () => {
          this.fetchReport();
        });
      });
    });
  }

  onSortChanged = (event, data) => {
    const { value } = data;
    this.setState({
      sort: value,
    });
  }

  onDateFilterChange = (date, dateType) => {
    const { datePeriodFilter } = this.state;
    const { location: { pathname } } = this.props;

    datePeriodFilter[dateType] = moment(date);
    console.log(dateType, date);
    this.setState({
      datePeriodFilter,
    }, () => {
      const searchStart =
        _.get(datePeriodFilter, 'start') ? `start=${_.get(datePeriodFilter, 'start').format('YYYY-MM-DD')}&` : '';
      const searchEnd =
        _.get(datePeriodFilter, 'end') ? `end=${_.get(datePeriodFilter, 'end').format('YYYY-MM-DD')}` : '';

      const search = searchStart + searchEnd;

      this.context.router.history.replace({ pathname, search });

      if (shouldReloadOnPeriodFilter(this.state.datePeriodFilter)) {
        this.fetchReport();
      }
    });
  }

  onReportPerDaysChanged = (e, option) => {
    const { id, type } = this.props.match.params;
    this.props.history.push({
      pathname: `/report/${id}/${type}/${option.value}`,
    });
    this.setState({
      reportPerDays: option,
      isLoadingReport: true,
      isReportLoaded: false,
    }, this.fetchReport);
  }

  getProfile = () => {
    // Retrieves the profile data from localStorage
    const profile = localStorage.getItem(PROFILE_KEY);
    return profile ? JSON.parse(profile) : null;
  }

  setProfile = profile => {
    localStorage.setItem(PROFILE_KEY, JSON.stringify(profile));
    this.setState({
      profile,
    }, this.notify);
  }


  notify = () => {
    const { profile, campaign } = this.state;
    const { href } = window.location;

    if (profile) {
      const notification = {
        data: {
          profile,
          campaign,
          href,
        },
      };

      if (IS_PRODUCTION) {
        this.notifyClient.post('/', notification)
          .then(() => console.log('notified OK.'))
          .catch(e => console.log(e));
      } else {
        console.log(`no notifications on ${window.location.hostname}`);
      }
    }
  }


  hasMarketingCampaigns = marketingCampaigns => marketingCampaigns && !_.isEmpty(marketingCampaigns)

  fetchReport = forceRefresh => {
    const { id, type } = this.props.match.params;
    const { profile, reportPerDays, campaign: { campaignType, marketingCampaigns }, datePeriodFilter } = this.state;

    const isCollaborationReport = this.isCollaborationReport();

    this.setState({
      isLoadingReport: true,
      isReportLoaded: false,
    });

    const isACR = campaignType === 'ACR';
    const allDaysOptionSelected = _.get(reportPerDays, 'value', 0) === -1;
    const daysFilter = reportPerDays ? reportPerDays.value : DEFAULT_PER_DAYS;
    const shouldFilterByDays = isACR && !allDaysOptionSelected;

    const { start: startDate, end: endDate } = datePeriodFilter;
    const canFilterByDatePeriod = !_.isNil(startDate) || !_.isNil(endDate);

    const params = {
      type: type === 'shopify' || type === 'followers' || type === 'prestashop' ? 'roi' : type,
      id,
      days: shouldFilterByDays ? daysFilter : undefined,
      startDate: canFilterByDatePeriod && !_.isNil(startDate) ? startDate.format('YYYY-MM-DD') : undefined,
      endDate: canFilterByDatePeriod && !_.isNil(endDate) ? endDate.format('YYYY-MM-DD') : undefined,
    };

    if (forceRefresh) {
      params.forceRefresh = true;
    }

    if (isCollaborationReport) {
      params.t = 'c';
    }

    const hasMarketingCampaign = this.hasMarketingCampaigns(marketingCampaigns);

    if (id === 'csa-super' && type === 'super') {
      return this.client.get('csa/super/report').then(response => {
        const { data } = response.data;

        console.log(data);
        const posts = _.filter(data.data.posts, (post => !_.isNull(post) && !_.isUndefined(post.trackedAsset)));
        console.log(posts);
        data.data.posts = posts;

        return this.setState({
          data,
          id,
          type,
          isLoadingReport: false,
          profile,
          isReportLoaded: true,
          isLoadingMarketingCampaigns: hasMarketingCampaign,
        }, this.notify);
      }).catch(e => {
        console.log(e);
        this.setState({
          loading: false, error: true,
        });
      });
    }

    // Temporary hack
    if (params.type === 'instagram-custom') {
      params.type = 'instagram';
    }

    if (params.type === 'campaign-insights') {
      params.type = 'instagram';
    }

    if (params.type === 'tiktok') {
      params.type = 'instagram';
    }

    console.log('SHOULD NOT GET HERE');
    return this.client.get('report', { params }).then(response => {
      const { data } = response;
      if (isBasicReport(type)) {
        const posts = _.filter(data.data.posts, (post => !_.isNull(post) && !_.isUndefined(post.trackedAsset)));
        data.data.posts = posts;
        console.log(data.data);
      }
      this.setState({
        data,
        id,
        type,
        profile,
        isLoadingMarketingCampaigns: hasMarketingCampaign,
      }, this.notify);
    })
      .then(() => {
        if (hasMarketingCampaign) {
          return this.client.get(`marketing/campaign/by-id/${id}`)
            .then(response => {
              const { ads } = response.data.data;
              return this.setState({
                ads,
                isLoadingMarketingCampaigns: false,
                loadingMarketingCampaignsFailed: false,
                isLoadingReport: false,
                isReportLoaded: true,
              });
            }).catch(() => {
              this.setState({
                ads: [],
                isLoadingMarketingCampaigns: false,
                loadingMarketingCampaignsFailed: true,
                isLoadingReport: false,
                isReportLoaded: true,
              });
            });
        }

        this.setState({
          isLoadingReport: false,
          isReportLoaded: true,
        });

        return null;
      })
      .catch(error => {
        console.log(error.message);
        this.setState({
          isLoadingReport: false,
          isReportLoaded: true,
          error,
          profile,
          campaign: { name: 'error loading campaign' },
        }, this.notify);
      });
  }

  forceRefresh = () => {
    const forceRefresh = true;
    return this.fetchReport(forceRefresh);
  }

  onOrderChanged = (field, value) => {
    const { order } = this.state;
    order.basic = {
      field,
      value,
    };
    this.setState({
      order,
    });
  }

  onGroupByChanged = (event, data) => {
    const { value } = data;
    this.setState({
      groupBy: value,
    });
  }

  onFilterChange = (event, data) => {
    const handle = _.get(data, 'children[2]');
    const { filter } = this.state;
    const { value } = data;
    const parts = _.split(value, '.');
    const val = parts.pop();
    const key = parts.pop();
    filter.basic[key] = val === 'reset' ? null : val;
    filter.instagramHandle = val === 'reset' ? undefined : handle;
    this.setState({
      filter,
    });
  }

  render() {
    const {
      data,
      error,
      sort,
      groupBy,
      filter,
      order,
      profile,
      reportPerDays,
      campaign,
      isLoadingCampaign,
      isLoadingReport,
      isReportLoaded,
      isReportBlocked,
      datePeriodFilter: datePeriodFilterState,
      ads,
      isLoadingMarketingCampaigns,
      loadingMarketingCampaignsFailed,
    } = this.state;

    const { type } = this.props.match.params;

    const isACR = campaign && campaign.campaignType === 'ACR';

    const bottomSpace = { height: 100, width: '100%' };
    const isProfileSet = Boolean(profile);
    const isProfileRequired = _.includes(PROFILE_REQUIRED_DOMAINS, window.location.hostname);

    const hasMarketingCampaign = this.hasMarketingCampaigns(campaign ? campaign.marketingCampaigns : null);
    const isBlendAds = (type === 'campaign') && (campaign && campaign.id) === BLEND_CAMPAIGN_ID;
    console.log(isBlendAds);

    const topHeaderProps = {
      name: _.get(campaign, 'name', ''),
      createdBy: _.get(campaign, 'createdBy', ''),
      headerInfo: {
        hasLogo: false,
        campaignName: _.get(campaign, 'name', ''),
        reportCountry: _.get(campaign, 'country'),
        reportType: reportTypes[type] || 'Campaign',
        hashtags: _.get(campaign, 'hashtags', ''),
        liveDate: _.get(campaign, 'liveDate', ''),
        endDate: _.get(campaign, 'endDate', ''),
      },
    };

    const shouldUseCustomMessage = isACR && _.includes([30, 90], _.toNumber(reportPerDays.value));
    const emptyCampaignText = shouldUseCustomMessage
      ? `No posts published in the last ${reportPerDays.value} days. Try increasing the days filter above to fetch earlier posts`
      : 'No posts included in this campaign';

    const datePeriodFilter = {
      start: datePeriodFilterState.start && datePeriodFilterState.start.format('DD/MM/YYYY'),
      end: datePeriodFilterState.end && datePeriodFilterState.end.format('DD/MM/YYYY'),
    };

    return (
      <div>

        <TopHeader
          isLoading={isLoadingCampaign}
          {...topHeaderProps}
          onForceRefresh={this.forceRefresh}
        />

        { isReportBlocked &&
          <Card style={{ textAlign: 'center' }} fluid>
            <Card.Content>
              <h2>
                <Icon name="clock" color="orange" />
                Generating Report
                <Icon name="clock" color="orange" />
              </h2>
            </Card.Content>
            <Card.Content>
              <p>We are currently fetching data for your report.</p>
              <p>Please check back shortly!</p>
            </Card.Content>
          </Card>
        }

        {
          isBasicReport(type) && isReportLoaded &&
          <div>
            <BasicReport
              data={data}
              sort={sort}
              order={order.basic}
              filter={filter.basic}
              instagramHandleFilter={_.get(this.state, 'filter.instagramHandle')}
              emptyCampaignText={emptyCampaignText}
              emptyCampaignMessageType={shouldUseCustomMessage ? 'warning' : 'info'}
              perDaysOption={reportPerDays}
              withDaysFilter={isACR}
              onPerDaysChanged={this.onReportPerDaysChanged}
              hasRightFilterOptions={false}
              onFilterChange={this.onFilterChange}
              daysOptions={daysOptions}
              onOrderChanged={this.onOrderChanged}
              withDatePeriodFilter={!isACR}
              datePeriodFilterValues={datePeriodFilter}
              onDateFilterChange={this.onDateFilterChange}
              onForceRefresh={this.forceRefresh}
              hasMarketingCampaigns={hasMarketingCampaign}
              isLoadingMarketingCampaigns={isLoadingMarketingCampaigns}
              loadingMarketingCampaignsFailed={loadingMarketingCampaignsFailed}
              ads={ads}
              shouldRenderShareableLinks={false}
            />
          </div>
        }

        {
          _.toLower(type) === 'paid' && isReportLoaded &&
          <div>
            <PaidReport
              data={data}
              sort={sort}
              order={order.basic}
              filter={filter.basic}
              emptyCampaignText={emptyCampaignText}
              emptyCampaignMessageType={shouldUseCustomMessage ? 'warning' : 'info'}
              perDaysOption={reportPerDays}
              withDaysFilter={isACR}
              onPerDaysChanged={this.onReportPerDaysChanged}
              hasRightFilterOptions={false}
              onFilterChange={this.onFilterChange}
              daysOptions={daysOptions}
              onOrderChanged={this.onOrderChanged}
              withDatePeriodFilter={!isACR}
              datePeriodFilterValues={datePeriodFilter}
              onDateFilterChange={this.onDateFilterChange}
              onForceRefresh={this.forceRefresh}
              hasMarketingCampaigns={hasMarketingCampaign}
              isLoadingMarketingCampaigns={isLoadingMarketingCampaigns}
              loadingMarketingCampaignsFailed={loadingMarketingCampaignsFailed}
              ads={ads}
              shouldRenderShareableLinks={false}
            />
          </div>
        }

        {
          _.toLower(type) === 'gi' && isReportLoaded &&
          <div>
            <PaidReport
              inGIMode
              data={data}
              sort={sort}
              order={order.basic}
              filter={filter.basic}
              emptyCampaignText={emptyCampaignText}
              emptyCampaignMessageType={shouldUseCustomMessage ? 'warning' : 'info'}
              perDaysOption={reportPerDays}
              withDaysFilter={isACR}
              onPerDaysChanged={this.onReportPerDaysChanged}
              hasRightFilterOptions={false}
              onFilterChange={this.onFilterChange}
              daysOptions={daysOptions}
              onOrderChanged={this.onOrderChanged}
              withDatePeriodFilter={!isACR}
              datePeriodFilterValues={datePeriodFilter}
              onDateFilterChange={this.onDateFilterChange}
              ads={ads}
              onForceRefresh={this.forceRefresh}
            />
          </div>
        }


        {
          _.toLower(type) === 'instagram' && isReportLoaded &&
          <InstagramReport
            data={data}
            sort={sort}
            groupBy={groupBy}
            onSortChanged={this.onSortChanged}
            onGroupByChanged={this.onGroupByChanged}
          />
        }

        {
          _.toLower(type) === 'instagram-custom' && isReportLoaded &&
          <InstagramReport2
            campaign={campaign}
            data={data}
            sort={sort}
            groupBy={groupBy}
            onSortChanged={this.onSortChanged}
            onGroupByChanged={this.onGroupByChanged}
            datePeriodFilterValues={datePeriodFilter}
            onDateFilterChange={this.onDateFilterChange}
          />
        }

        {
          _.toLower(type) === 'tiktok' && isReportLoaded &&
          <TiktokReport
            campaign={campaign}
            data={data}
            sort={sort}
            groupBy={groupBy}
            onSortChanged={this.onSortChanged}
            onGroupByChanged={this.onGroupByChanged}
            datePeriodFilterValues={datePeriodFilter}
            onDateFilterChange={this.onDateFilterChange}
          />
        }

        {
          _.toLower(type) === 'campaign-insights' && isReportLoaded &&
          <CampaignInsightsReport
            data={data}
          />
        }

        {
          _.toLower(type) === 'roi' && isReportLoaded &&
          <ROIReport
            onFilterChange={this.onFilterChange}
            filter={filter}
            {...data.data}
          />
        }

        {
          _.toLower(type) === 'followers' && isReportLoaded &&
          <FollowersReport
            onFilterChange={this.onFilterChange}
            filter={filter}
            {...data.data}
          />
        }

        {
          _.toLower(type) === 'shopify' && isReportLoaded &&
          <ShopifyReport
            onFilterChange={this.onFilterChange}
            filter={filter}
            {...data.data}
          />
        }

        {
          _.toLower(type) === 'prestashop' && isReportLoaded &&
          <PrestaShopReport
            onFilterChange={this.onFilterChange}
            filter={filter}
            {...data.data}
          />
        }

        {
          _.toLower(type) === 'ga' && isReportLoaded &&
          <GoogleAnalyticsReport
            onFilterChange={this.onFilterChange}
            filter={filter}
            data={data.data}
          />
        }
        {
          _.toLower(type) === 'emv' && isReportLoaded &&
          <EMVReport
            onFilterChange={this.onFilterChange}
            filter={filter}
            {...data.data}
          />
        }
        {
          _.toLower(type) === 'hero' && isReportLoaded &&
          <HeroReport
            data={data}
          />
        }

        {
          isReportLoaded && _.toLower(type) === 'insights' &&
          <InsightsReport
            data={data}
          />
        }
        {
          isReportLoaded && _.toLower(type) === 'auth' &&
          <AuthReport
            {...data.data}
            isLoading={isLoadingReport}
          />
        }

        {
          isReportLoaded && error && <Message
            error
            icon="warning circle"
            header="Something went wrong"
            content="Could not load report. Please try again later"
          />}

        {
          isProfileRequired &&
          <UserDetailsModal
            open={!isProfileSet}
            successHandler={this.setProfile}
          />
        }

        {
          isLoadingReport && !isReportBlocked &&
          <Segment style={loadingSegmentStyle}>
            <Dimmer active inverted>
              <Loader size="big">Loading report</Loader>
            </Dimmer>
          </Segment>
        }

        <div style={bottomSpace} />
      </div>
    );
  }
}

Report.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

Report.contextTypes = {
  router: PropTypes.object,
};

export default Report;



// WEBPACK FOOTER //
// ./src/containers/report/index.js